export const isSupportingDownload = () => 'download' in document.createElement('a');
